// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"8945b590","732":"8945b590","969":"0a53fe79"}[chunkId] + ".chunk.css";
};